<template>
  <div class="live-big-banner-player-cell">
    <instant-player
      :content-id="contentId"
      :content-type="contentType"
      :target-age="targetAge"
      :is-play-video="isActive"
      @on-click-player="handleClickPlayer"
    >
      <template #cell-component>
        <LiveBigBannerCell
          :cell-info="cellInfo"
          :thumbnail-info="thumbnailInfo"
          :is-active="isActive"
        />
      </template>
    </instant-player>
  </div>
</template>
<script setup>
  import InstantPlayer from '@/components/model/cell/instant-player/InstantPlayer.vue'
  import { useCell } from '@/common/use/useCell'
  import LiveBigBannerCell from '@/components/model/cell/LiveBigBannerCell.vue'

  const props = defineProps({
    cellInfo: {
      type: Object,
      default: null,
    },
    thumbnailInfo: {
      type: Object,
      default: null,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  })

  const { contentType, contentId, targetAge, goDetail } = useCell(
    props.cellInfo,
  )

  const handleClickPlayer = () => {
    goDetail(props.cellInfo)
  }
</script>
<style scoped lang="scss">
  .live-big-banner-player-cell {
    width: 100%;
    height: 100%;
    border-radius: 12px;
    overflow: hidden;
    transform: translateZ(0);
    .instant-player-cell {
      height: 100%;
      width: 100%;
      ::v-deep(.w-button-mute) {
        bottom: 12px;
        right: 12px;
      }
      ::v-deep(.player-spinner) {
        bottom: 12px;
        right: 12px;
      }
      ::v-deep(.video-area-wrap) {
        min-height: 378px;
        width: 75%;
        height: 100%;
        left: auto;
        right: 0;
        .video-area {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          height: 100%;
          aspect-ratio: 222/125;
        }
      }
      ::v-deep(.thumbnail-area-wrap) {
        min-height: 378px;
        height: 100%;
        width: 100%;
      }
    }
  }
</style>
